import React from 'react';

export default function HowToUseSmartTagsLink() {
  return (
    <div
      style={{
        textAlign: 'right',
        fontSize: '1.2rem',
        float: 'right'
      }}
    >
      <a
        href="https://help.nekst.com/en-us/article/smart-tags-pre-fill-your-emails-with-transaction-info-1w4f4be/"
        target="_blank"
        rel="noreferrer"
      >
        Type "#" to personalize a message (learn more)
      </a>
    </div>
  );
}
